import { useSearchParams } from "react-router-dom";
import { useMe, canReadAllMembers } from "../../auth/queries";
import { isID } from "../../lib/id";
import { PersonDetailModal } from "./PersonDetailModal";
import { PERSON_DETAIL_PARAM } from "./personDetailParam";

/**
 * PersonDetailHost renders the person detail dialog over any page whose URL
 * carries `?osoba=<id>`. Mounted once, in AppLayout. Only the registry's
 * readers (canReadAllMembers) get it; for anyone else the parameter is ignored, as
 * PersonLink never offers it to them.
 */
export function PersonDetailHost() {
  const [params, setParams] = useSearchParams();
  const { data: me } = useMe();
  const id = params.get(PERSON_DETAIL_PARAM);
  if (!isID(id) || !canReadAllMembers(me)) return null;

  // Closing REPLACES the entry the link pushed, so Back afterwards returns
  // to the page rather than reopening the dialog.
  const close = () =>
    setParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        next.delete(PERSON_DETAIL_PARAM);
        return next;
      },
      { replace: true },
    );
  // Keyed by id: a link from inside the dialog to another person starts it
  // fresh on the first tab.
  return <PersonDetailModal key={id} personId={id} onClose={close} />;
}
